import { useSymbolStore } from '@/stores/symbol';
import PanelContainer from '../panel-container';
import SymbolContainer from '../symbol-container';
import StickerBlocks from './sticker-blocks';
import StickerCategories from './sticker-categories';

const StickerPanel = () => {
  const selectedSymbol = useSymbolStore((s) => s.selectedSymbol);

  return (
    <PanelContainer visible={selectedSymbol === 'sticker'}>
      <StickerCategories />
      <SymbolContainer slug={selectedSymbol}>
        <StickerBlocks />
      </SymbolContainer>
    </PanelContainer>
  );
};

export default StickerPanel;
